import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dateFormat', standalone: false })
export class DateFormatPipe implements PipeTransform {
  transform(value: Date | string | number, format = 'shortDate'): string {
    return formatDate(value, format, 'en-US');
  }
}
